<template>
    <div style="width:512px;height:300px;margin:auto" class="palyer2">
        <LivePlayer  @snapOutside="snapOutside" ref="player2" :videoUrl="videoUrl" live />
    </div>
</template>

<script>
import LivePlayer from  '@liveqing/liveplayer'
export default {
    name: 'LivePlayerDemo',
    components: {
        LivePlayer
    },
    props: {
        msg: String,
        videoUrl: String
    },
    computed: {
        // flvURL() {
        //     return `${location.protocol}//${location.host}/video.flv`
        // }
    },
    methods: {
        pause: function () {
            this.$refs.player2.pause();
        },
        play: function (url) {
            console.log(".........................."+url);
            this.videoUrl = url;
            this.$refs.player2.play();
        },
        snap: function () {
            this.$refs.player2.snap();
        },
        snapOutside: function (snapData) {
            alert(snapData)
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
h3 {
    margin: 40px 0 0;
}

ul {
    list-style-type: none;
    padding: 0;
}

li {
    display: inline-block;
    margin: 0 10px;
    cursor: pointer;
}

a {
    color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/LivePlayerDemo.vue